import * as yup from 'yup';

export function useFollowUpFiltersSchema() {
   const { t } = useI18n();

   const FOLLOW_UP_FILTERS_SCHEMA = yup.object().shape({
      employer_id: yup.mixed().notRequired(),
      candidate_sync_id: yup.string().notRequired(),
      case_file_type_ids: yup.array().of(yup.string()).notRequired(),
      progression_state_ids: yup.array().of(yup.string()).notRequired(),
      customer_ids: yup.array().of(yup.number()).notRequired(),
      show_my_case_files: yup.string().oneOf(['0', '1']).notRequired(),
      from: yup.string().notRequired().label(t('generic.dates.from')),
      till: yup
         .string()
         .notRequired()
         .label(t('generic.dates.till'))
         .test('till-after-from', t('generic.feedback.end-after-start'), function (value) {
            const { from } = this.parent;
            if (!value || !from) return true;

            return value >= from;
         }),
   });

   return { FOLLOW_UP_FILTERS_SCHEMA };
}
